<span [tooltip]="value | number:tooltipDigitsInfo" class="wrapped" container="body" delay="500">{{value | shortNumber}}</span>
